var React = require('react');

function M1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"M1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"49.66 41.01 42.96 24.49 33.02 0 0 82.38 33.08 82.38 66.16 82.38 66.45 82.38 49.66 41.01","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"96.98 86.23 66.83 4.31 48.33 37.55 59.58 86.23 96.98 86.23","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

M1.defaultProps = {"viewBox":"0 0 96.98 86.23"};

module.exports = M1;

M1.default = M1;
